import { Box, Drawer } from '@mui/material';
import Button from '../../Button/Button';
import DrawerHeader from '../../Drawer/components/DrawerHeader';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UserHistoryContainer from '../../UserHistoryContainer/UserHistoryContainer';

function HistorialDocumentos({ openHistory, onClose }: any) {
    return (
        <Drawer
            anchor="right"
            open={!!openHistory}
            onClose={onClose}
            sx={{
                '& .MuiPaper-root': {
                    width: { xs: '100%', sm: '606px' }
                }
            }}
        >
            <Box className="drawer-container">
                <DrawerHeader onClose={onClose} icon={<ArrowBackIcon />} title="Mi historial" />
                <Box className="drawer-body">
                    <UserHistoryContainer openDrawer={openHistory} />
                </Box>
                <Box className="drawer-actions">
                    <Button onClick={onClose}>Volver</Button>
                </Box>
            </Box>
        </Drawer>
    );
}

export default HistorialDocumentos;
